import React, { useState, useEffect } from "react";
import {
  Container,
  Col,
  Form,
  Row,
  Spinner,
  Table,
  Button,
  Modal,
  Alert,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import messages from "../../redux/messages";
import * as Yup from "yup";

import {
  getPlanIndividual,
  savePlanCurso,
  savePlanCompetencia,
  editPlanCompetencias,
  editPlanCurso,
  deletePlanCurso,
  deletePlanCompetencia

} from "../../redux/planCarrera/PlanIndividual/actions"

import { getPlanById } from "../../redux/planCarrera/Plan/actions"
import { Formik } from "formik";

import {
  getCourseFun
} from "../../redux/planCarrera/CursosFunciones/actions";
import {
  getCompetencyFun
} from "../../redux/planCarrera/CompetenciasFunciones/actions";
import { getStatus } from "../../redux/planCarrera/Estados/actions";

import { Typeahead } from "react-bootstrap-typeahead";
import moment from "moment";


const PlanCarreraIndividual = (props) => {
  const [show, setShow] = useState(false);
  const [showModalCurso, setShowModalCurso] = useState(false);
  const [showModalCompetencia, setShowModalCompetencia] = useState(false);
  const [editCurso, setEditCurso] = useState(false);
  const [editCompetencia, setEditCompetencia] = useState({});
  const [validatedCurso, setValidatedCurso] = useState(false);
  const [validatedCompetencia, setValidatedCompetencia] = useState(false);
  const [indexCurso, setIndexCurso] = useState();
  const [indexCompetencia, setIndexCompetencia] = useState();
  const dispatch = useDispatch();
  const headerStyle = "bg-dark text-white";

  const schemaCurso = Yup.object().shape({
    curso: Yup.string().required("**Campo requerido")
      .test(
        "uniqueCurso",
        "** Ya se ha agregado este mismo curso.",
        function (value) {
          if (!value || editCurso || !planIndividual.cursos) return true;
          return !planIndividual.cursos.some(course => course.curso == value);
        }

      ),
    comentario: Yup.string(),
    estado: Yup.string().required("**Campo requerido"),
    documento: Yup.mixed()
      .test(
        "fileRequired",
        "**El archivo no puede estar vacío",
        value => {
          if (!value) {
            return true;
          }
          return value && value.size > 0;
        }
      )

  });

  const schemaCompetencia = Yup.object().shape({
    competencia: Yup.string().required("**Campo requerido")
      .test(
        "uniqueCompetencia",
        "** Ya se ha agregado esta misma competencia.",
        function (value) {
          if (!value || editCompetencia || !planIndividual.competencias) return true;
          return !planIndividual.competencias.some(competency => competency.competencia == value);
        }

      ),
    comentario: Yup.string(),
    estado: Yup.string().required("**Campo requerido"),
    documento: Yup.mixed()
      .test(
        "fileRequired",
        "**El archivo no puede estar vacío",
        value => {
          if (!value) {
            return true; // Si no hay archivo, está bien
          }
          return value && value.size > 0; // Si hay archivo, asegúrate de que no esté vacío
        }
      )

  });

  const {
    loading,
    saveLoading,
    planIndividual,
    planIndividualError,
    formError
  } = useSelector((store) => store.planCarreraPlanIndividual)

  const {
    plan: planEncabezado,
    loadingById: loadingPlanEncabezado
  } = useSelector((store) => store.planCarreraPlan);

  const {
    coursesFuncion
  } = useSelector((store) => store.planCarreraCoursesTasks);

  const {
    competenciesFun
  } = useSelector((store) => store.planCarreraCompetenciesFun);

  const {
    loading: loadingStatuses,
    statuses
  } = useSelector((store) => store.planCarreraStatus);

  useEffect(() => {

    dispatch(getCourseFun({
      tipo_busqueda: "funcion_codigo",
      filter: props.match.params.codFuncion
    }))

    dispatch(getCompetencyFun({
      tipo_busqueda: "funcion_codigo",
      filter: props.match.params.codFuncion
    }))

    dispatch(getStatus());
    dispatch(getPlanById(props.match.params.planId));

  }, [])

  let cursosFuncionOptions = [];

  if (coursesFuncion) {
    cursosFuncionOptions = coursesFuncion.map((course) => ({
      id: course.id,
      label: course.list_curso
        ? `${course.list_curso[0].codigo} / ${course.list_curso[0].nombre.toUpperCase()}`
        : "",
      item: course,
    }));
  }

  let competenciasFuncionOptions = [];

  if (competenciesFun) {
    competenciasFuncionOptions = competenciesFun.map((competency) => ({
      id: competency.id,
      label: competency.list_competencia
        ? `${competency.list_competencia[0].codigo} / ${competency.list_competencia[0].nombre.toUpperCase()}`
        : "",
      item: competency,
    }));
  }

  const statusesOptions = statuses
    ? statuses.map((item) => ({
      id: item.id,
      label: item.nombre.toUpperCase(),
      item: item,
    }))
    : [];

  const estadoCerrado = statuses.filter((item) => item.nombre.toUpperCase() === "CERRADO")
  const estadoPendiente = statuses.filter((item) => item.nombre.toUpperCase() === "PENDIENTE")

  const _getPlanCarreraIndividual = () => {
    dispatch(getPlanIndividual({
      plan_id: props.match.params.planId
    }));

  }


  useEffect(() => {
    _getPlanCarreraIndividual()
  }, [])

  const onAddCurso = () => {
    setEditCurso(false)
    setShowModalCurso(true);
    setValidatedCurso(false)
  }

  const onAddCompetencia = () => {
    setEditCompetencia(false)
    setShowModalCompetencia(true);
    setValidatedCompetencia(false)
  }

  const onEditCurso = (item, index) => {
    setEditCurso(item)
    setIndexCurso(index)
    setValidatedCurso(false)
    setShowModalCurso(true);

  }

  const onEditCompetencia = (item, index) => {
    setEditCompetencia(item)
    setIndexCompetencia(index)
    setValidatedCompetencia(false)
    setShowModalCompetencia(true)
  }

  const onDeleteCurso = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deletePlanCurso(id, index, { plan_id: props.match.params.planId }));

    }
  }

  const onDeleteCompetencia = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deletePlanCompetencia(id, index, { plan_id: props.match.params.planId }));

    }
  }


  const onSubmitCurso = async (req) => {
    let formData = new FormData()
    formData.append("plan", props.match.params.planId)
    formData.append("comentario", req.comentario)
    formData.append("estado", req.estado)
    if (req.documento) formData.append("documento", req.documento)
    if (editCurso) {
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      dispatch(editPlanCurso(formData, editCurso.id, indexCurso, setShowModalCurso, { plan_id: props.match.params.planId }))
    } else {
      formData.append("curso", req.curso)
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }
      dispatch(savePlanCurso(formData, setShowModalCurso, { plan_id: props.match.params.planId }))
    }
    console.log(estadoPendiente, estadoCerrado, req.estado)


  }

  const onSubmitCompetencia = async (req) => {
    let formData = new FormData()
    formData.append("plan", props.match.params.planId)
    formData.append("comentario", req.comentario)
    formData.append("estado", req.estado)
    if (req.documento) formData.append("documento", req.documento)
    if (editCompetencia) {
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      dispatch(editPlanCompetencias(formData, editCompetencia.id, indexCompetencia, setShowModalCompetencia, { plan_id: props.match.params.planId }))
    } else {
      formData.append("competencia", req.competencia)
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }
      dispatch(savePlanCompetencia(formData, setShowModalCompetencia, { plan_id: props.match.params.planId }))
    }
    console.log(estadoPendiente, estadoCerrado, req.estado)


  }


  function DownloadDocument({ documentPath }) {
    const baseURL = process.env.REACT_APP_URL;
    const documentURL = `${baseURL}media/${documentPath}`;
    const fileName = documentPath.split("/").pop();

    return (

      <OverlayTrigger overlay={<Tooltip>Descargar {fileName}</Tooltip>}>
        <a href={documentURL} download>
          <Button
            size="sm"
            className="text-primary"
            variant="link"
            type="button"
          >
            <i className="material-icons">download</i>
          </Button>
        </a>
      </OverlayTrigger>

    );
  }


  const onShowSidebar = () => setShow(show ? false : true);
  const cursosCerradosCounter = planIndividual?.cursos ? planIndividual.cursos.filter((item) => item.list_estado?.[0]?.id === estadoCerrado?.[0]?.id).length : 0
  const totalCursos = planIndividual?.cursos ? planIndividual?.cursos.length : 0
  const porcentajeCompletadoCursos = ((cursosCerradosCounter / totalCursos) * 100).toFixed(2)

  const competenciasCerradasCounter = planIndividual?.competencias ? planIndividual.competencias.filter((item) => item.list_estado?.id === estadoCerrado?.[0]?.id).length : 0
  const totalCompetencias = planIndividual?.competencias ? planIndividual?.competencias.length : 0
  const porcentajeCompletadoCompetencias = ((competenciasCerradasCounter / totalCompetencias) * 100).toFixed(2)



  return (
    <>
      {(loading || saveLoading || loadingStatuses || loadingPlanEncabezado) ? (
        <div className='d-flex justify-content-center'>
          <Spinner
            animation='border'
            role='status'
            className='d-flex justify-content-center'
          />
        </div>
      ) : (
        <div>
          <Container fluid className="mb-5 mt-5 ">
            <Table bordered responsive className="table-sm">
              <tbody>
                <tr>
                  <td className="bg-dark text-white">Empleado: </td>
                  <td>{planIndividual?.colaborador?.[0]?.nombre.toUpperCase()}</td>
                  <td className="bg-dark text-white">Posición Actual: </td>
                  <td>{planIndividual?.colaborador?.[0]?.Funciones_List?.[0]?.codigo} / {planIndividual?.colaborador?.[0]?.Funciones_List?.[0]?.descripcion.toUpperCase()}</td>
                  <td className="bg-dark text-white">Empresa: </td>
                  <td>{planIndividual?.colaborador?.[0]?.empresa?.[0].toUpperCase()}</td>
                </tr>
                <tr>
                  <td className="bg-dark text-white">Fecha Creación: </td>
                  <td>{moment(planIndividual?.plan_fecha_inicio).format("DD-MM-YYYY")}</td>
                  <td className="bg-dark text-white">Fecha de Finalización: </td>
                  <td>{moment(planIndividual?.plan_fecha_fin).format("DD-MM-YYYY")}</td>
                  <td className="bg-dark text-white text-center align-middle" rowSpan={2}>Avance</td>
                  <td rowSpan={2} className="text-center align-middle">{planIndividual?.plan_avance}%</td>
                </tr>
                <tr>
                  <td className="bg-dark text-white">Jefe Directo: </td>
                  <td>{planIndividual?.colaborador?.[0]?.jefe?.[0]?.nombre.toUpperCase()}</td>
                  <td className="bg-dark text-white">Responsable:</td>
                  <td>{planIndividual?.responsable?.[0]?.nombre.toUpperCase()}</td>
                </tr>
              </tbody>
            </Table>

          </Container>

          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th className="text-center">Avance Ruta de Aprendizaje</th>
              </tr>
              <tr>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }} className="text-center">{!isNaN(porcentajeCompletadoCursos) ? porcentajeCompletadoCursos : "0.00"}%</th>
              </tr>
              <tr>
                <th rowSpan={2} style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th rowSpan={2}>No.</th>
                <th className="text-center" style={{ width: "270px" }} colSpan={4}>{planEncabezado?.list_funciones?.[0]?.descripcion}</th>

                <th rowSpan={2} style={{ backgroundColor: "#fff", border: "0px" }}>
                  <Button
                    variant="primary"
                    onClick={onAddCurso}
                  >
                    Agregar Formación
                  </Button></th>
                <th className="text-center" style={{ width: "200px" }} ></th>
              </tr>
              <tr>
                <th>Formación</th>
                <th>Estado</th>
                <th>Descripción</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <td rowSpan={totalCursos + 1} style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', textAlign: 'center', fontWeight: "bold" }}>
                Ruta de Aprendizaje
              </td>

              {(planIndividual?.cursos && totalCursos > 0) ?
                planIndividual.cursos.map((curso, index) => {

                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{`${curso?.list_curso?.[0]?.list_curso?.[0]?.codigo}/${curso?.list_curso?.[0]?.list_curso?.[0]?.nombre.toUpperCase()} `}</td>
                      <td>{curso.list_estado[0].nombre.toUpperCase()}</td>
                      <td>
                        {curso.comentario}
                      </td>
                      <td>
                        {curso.estado !== estadoCerrado?.[0]?.id && (
                          <OverlayTrigger overlay={<Tooltip>Editar Formación</Tooltip>}>
                            <Button
                              size="sm"
                              className="text-primary"
                              variant="link"
                              type="button"
                              onClick={() => onEditCurso(curso, index)}
                            >
                              <i className="material-icons">edit</i>
                            </Button>
                          </OverlayTrigger>
                        )
                        }

                        {curso.documento && (
                          <DownloadDocument documentPath={curso.documento} />
                        )}

                        <OverlayTrigger overlay={<Tooltip>Eliminar Formación</Tooltip>}>
                          <Button
                            size="sm"
                            className="text-danger"
                            variant="link"
                            type="button"
                            onClick={() => onDeleteCurso(curso.id, index)}
                          >
                            <i className="material-icons">delete</i>
                          </Button>
                        </OverlayTrigger>

                      </td>

                      {index === 0 && (
                        <td rowSpan={totalCursos} style={{ backgroundColor: "#fff", border: "0px" }}></td>
                      )}

                      <td className="text-center">
                        {curso.estado === estadoCerrado?.[0]?.id ? (
                          <i className="material-icons text-success">check</i>
                        ) : (<i className="material-icons text-danger">close</i>)}


                      </td>
                    </tr>
                  )

                })
                :
                (


                  <td style={{ backgroundColor: "#fff", border: "0px" }} colSpan={2}>
                    <Alert variant="info">
                      No hay cursos registrados, comience agregando algunos.
                    </Alert>
                  </td>

                )

              }

            </tbody>
          </Table>

          <Table striped bordered hover responsive>
            <thead>
              {console.log(estadoPendiente)}
              <tr>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th className="text-center">Avance Competencias</th>
              </tr>
              <tr>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th style={{ backgroundColor: "#fff", border: "0px" }} className="text-center">{!isNaN(porcentajeCompletadoCompetencias) ? porcentajeCompletadoCompetencias : "0.00"}%</th>
              </tr>
              <tr>
                <th rowSpan={2} style={{ backgroundColor: "#fff", border: "0px" }}></th>
                <th rowSpan={2}>No.</th>
                <th className="text-center" style={{ width: "270px" }} colSpan={4}>{planEncabezado?.list_funciones?.[0]?.descripcion}</th>

                <th rowSpan={2} style={{ backgroundColor: "#fff", border: "0px" }}>
                  <Button
                    variant="primary"
                    onClick={onAddCompetencia}
                  >
                    Agregar Competencia
                  </Button></th>
                <th className="text-center" style={{ width: "200px" }} ></th>
              </tr>
              <tr>
                <th>Competencia</th>
                <th>Estado</th>
                <th>Descripción</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <td rowSpan={totalCompetencias + 1} style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', textAlign: 'center', fontWeight: "bold" }}>
                Competencias
              </td>

              {(planIndividual?.competencias && totalCompetencias > 0) ?
                planIndividual.competencias.map((competencia, index) => {

                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{`${competencia.list_competencia.list_competencia[0].codigo}/${competencia.list_competencia.list_competencia[0].nombre.toUpperCase()} `}</td>
                      <td>{competencia.list_estado.nombre.toUpperCase()}</td>
                      <td>
                        {competencia.comentario}
                      </td>

                      <td>
                        {competencia.estado !== estadoCerrado?.[0]?.id && (
                          <OverlayTrigger overlay={<Tooltip>Editar Competencia</Tooltip>}>
                            <Button
                              size="sm"
                              className="text-primary"
                              variant="link"
                              type="button"
                              onClick={() => onEditCompetencia(competencia, index)}
                            >
                              <i className="material-icons">edit</i>
                            </Button>
                          </OverlayTrigger>

                        )
                        }

                        {competencia.documento && (
                          <DownloadDocument documentPath={competencia.documento} />
                        )}

                        <OverlayTrigger overlay={<Tooltip>Eliminar Competencia</Tooltip>}>
                          <Button
                            size="sm"
                            className="text-danger"
                            variant="link"
                            type="button"
                            onClick={() => onDeleteCompetencia(competencia.id, index)}
                          >
                            <i className="material-icons">delete</i>
                          </Button>
                        </OverlayTrigger>

                      </td>

                      {index === 0 && (
                        <td rowSpan={totalCompetencias} style={{ backgroundColor: "#fff", border: "0px" }}></td>
                      )}

                      <td className="text-center">
                        {competencia.estado === estadoCerrado?.[0]?.id ? (
                          <i className="material-icons text-success">check</i>
                        ) : (<i className="material-icons text-danger">close</i>)}


                      </td>
                    </tr>
                  )

                })
                :
                (


                  <td style={{ backgroundColor: "#fff", border: "0px" }} colSpan={2}>
                    <Alert variant="info">
                      No hay competencias registradas, comience agregando algunas.
                    </Alert>
                  </td>

                )

              }

            </tbody>
          </Table>


          <Modal
            show={showModalCurso}
            onHide={() => {
              setShowModalCurso(false);
            }}
          >
            <Formik
              validationSchema={schemaCurso}
              onSubmit={onSubmitCurso}
              initialValues={{
                curso: editCurso ? editCurso.id : "",
                comentario: editCurso ? editCurso.comentario : "",
                estado: editCurso ? editCurso.estado : estadoPendiente?.[0]?.id,
                documento: ""
              }}

            >

              {({
                handleSubmit,
                handleChange,
                handleBlur,
                setFieldValue,
                values,
                touched,
                errors,
              }) => (


                <Form onSubmit={handleSubmit} noValidate validated={validatedCurso}>
                  <Modal.Header closeButton>
                    <Modal.Title className="text-muted">
                      {editCurso ? "Editar Formación" : "Agregar Formación"}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {formError && (
                      <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                        {formError}
                      </Alert>
                    )}

                    <Form.Group className="mb-3">
                      <Form.Label column sm="12" md="12">
                        Formación:
                      </Form.Label>
                      <Row className="d-flex flex-wrap align-items-center">
                        <Col sm={11} xs={11}>
                          <Typeahead
                            id="curso"
                            name="curso"
                            isInvalid={touched.curso && errors.curso}
                            isValid={touched.curso && !errors.curso}
                            onBlur={handleBlur("curso")}
                            placeholder="Seleccione un curso"
                            options={cursosFuncionOptions}
                            value={values.curso}
                            onChange={(selected) => {
                              setFieldValue(
                                "curso",
                                selected?.length > 0 ? selected[0].id : "",

                              );

                            }}
                            disabled={!!editCurso}
                            defaultInputValue={editCurso ? `${editCurso?.list_curso?.[0]?.list_curso?.[0]?.codigo} / ${editCurso?.list_curso?.[0]?.list_curso?.[0]?.nombre.toUpperCase()}` : ""}

                          >

                          </Typeahead>
                          <div className="text-danger mt-2">
                            {errors.curso}
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label column sm="12" md="12">
                        Descripción
                      </Form.Label>
                      <Row className="d-flex flex-wrap align-items-center">
                        <Col sm={11} xs={11}>
                          <Form.Control
                            id="comentario"
                            name="comentario"
                            isInvalid={touched.comentario && errors.comentario}
                            isValid={touched.comentario && !errors.comentario}
                            onBlur={handleBlur("comentario")}
                            onChange={handleChange}
                            value={values.comentario}
                            className="rounded-pill mb-4"
                            type="text"
                            placeholder="descripción"
                          ></Form.Control>

                        </Col>
                        <div className="text-danger">
                          {errors.comentario}
                        </div>
                      </Row>

                    </Form.Group>
                    {editCurso && (
                      <Form.Group className="mb-3">
                        <Form.Label column sm="12" md="12">
                          Estado:
                        </Form.Label>
                        <Row className="d-flex flex-wrap align-items-center">
                          <Col sm={11} xs={11}>
                            <Typeahead
                              id="estado"
                              name="estado"
                              isInvalid={touched.estado && errors.estado}
                              isValid={touched.estado && !errors.estado}
                              onBlur={handleBlur("estado")}
                              placeholder="Seleccione un estado"
                              options={statusesOptions}
                              value={values.estado}
                              onChange={(selected) => {
                                setFieldValue(
                                  "estado",
                                  selected?.length > 0 ? selected[0].id : "",

                                );

                              }}
                              defaultInputValue={editCurso ? `${editCurso?.list_estado?.[0]?.nombre.toUpperCase()}`
                                : ""}

                            >

                            </Typeahead>

                            <div className="text-danger">
                              {errors.estado}
                            </div>
                          </Col>
                        </Row>
                      </Form.Group>
                    )}
                    <Form.Group>
                      <Form.Label className="custom-file-upload">
                        <i className="material-icons m-1">upload_file</i>
                        <input
                          type="file"
                          name="documento"
                          id="documento"
                          onChange={(e) => setFieldValue("documento", e.target.files[0])}
                        />
                        {editCurso.documento ? "Cambiar archivo" : "Subir archivo"}
                      </Form.Label>
                      <span className="file-name">{values.documento ? `${values.documento.name}` : editCurso.documento ? editCurso.documento.split("/").pop() : 'No se ha seleccionado un archivo'}</span>
                      {errors.documento && (
                        <div>
                          <span className="text-danger">{errors.documento}</span>
                        </div>
                      )}
                    </Form.Group>

                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      className="rounded-pill"
                      variant="secondary"
                      onClick={() => setShowModalCurso(false)}
                    >
                      Cerrar
                    </Button>
                    <Button
                      className="rounded-pill"
                      variant="primary"
                      disabled={saveLoading}
                      type="submit"


                    >
                      {" "}
                      {saveLoading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />

                      )}
                      Guardar

                    </Button>
                  </Modal.Footer>
                </Form>
              )}
            </Formik>

          </Modal>

          <Modal
            show={showModalCompetencia}
            onHide={() => {
              setShowModalCompetencia(false);
            }}
          >
            <Formik
              validationSchema={schemaCompetencia}
              onSubmit={onSubmitCompetencia}
              initialValues={{
                competencia: editCompetencia ? editCompetencia.id : "",
                comentario: editCompetencia ? editCompetencia.comentario : "",
                estado: editCompetencia ? editCompetencia.estado : estadoPendiente?.[0]?.id,
                documento: ""
              }}

            >

              {({
                handleSubmit,
                handleChange,
                handleBlur,
                setFieldValue,
                values,
                touched,
                errors,
              }) => (


                <Form onSubmit={handleSubmit} noValidate validated={validatedCompetencia}>
                  <Modal.Header closeButton>
                    <Modal.Title className="text-muted">
                      {editCompetencia ? "Editar Competencia" : "Agregar Competencia"}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {formError && (
                      <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                        {formError}
                      </Alert>
                    )}

                    <Form.Group className="mb-3">
                      <Form.Label column sm="12" md="12">
                        Competencia:
                      </Form.Label>
                      <Row className="d-flex flex-wrap align-items-center">
                        <Col sm={11} xs={11}>
                          <Typeahead
                            id="competencia"
                            name="competencia"
                            isInvalid={touched.competencia && errors.competencia}
                            isValid={touched.competencia && !errors.competencia}
                            onBlur={handleBlur("competencia")}
                            placeholder="Seleccione una competencia"
                            options={competenciasFuncionOptions}
                            value={values.competencia}
                            onChange={(selected) => {
                              setFieldValue(
                                "competencia",
                                selected?.length > 0 ? selected[0].id : "",

                              );

                            }}
                            disabled={!!editCompetencia}
                            defaultInputValue={editCompetencia ? `${editCompetencia?.list_competencia?.list_competencia?.[0]?.codigo} / ${editCompetencia?.list_competencia?.list_competencia?.[0]?.nombre.toUpperCase()}` : ""}
                          >
                          </Typeahead>
                          <div className="text-danger mt-2">
                            {errors.competencia}
                          </div>
                        </Col>

                      </Row>

                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label column sm="12" md="12">
                        Descripción
                      </Form.Label>
                      <Row className="d-flex flex-wrap align-items-center">
                        <Col sm={11} xs={11}>
                          <Form.Control
                            id="comentario"
                            name="comentario"
                            isInvalid={touched.comentario && errors.comentario}
                            isValid={touched.comentario && !errors.comentario}
                            onBlur={handleBlur("comentario")}
                            onChange={handleChange}
                            value={values.comentario}
                            className="rounded-pill mb-4"
                            type="text"
                            placeholder="descripción"
                          ></Form.Control>

                        </Col>
                        <div className="text-danger">
                          {errors.comentario}
                        </div>
                      </Row>

                    </Form.Group>
                    {editCompetencia && (
                      <Form.Group className="mb-3">
                        <Form.Label column sm="12" md="12">
                          Estado:
                        </Form.Label>
                        <Row className="d-flex flex-wrap align-items-center">
                          <Col sm={11} xs={11}>
                            <Typeahead
                              id="estado"
                              name="estado"
                              isInvalid={touched.estado && errors.estado}
                              isValid={touched.estado && !errors.estado}
                              onBlur={handleBlur("estado")}
                              placeholder="Seleccione un estado"
                              options={statusesOptions}
                              value={values.estado}
                              onChange={(selected) => {
                                setFieldValue(
                                  "estado",
                                  selected?.length > 0 ? selected[0].id : "",

                                );

                              }}
                              defaultInputValue={editCompetencia ? `${editCompetencia?.list_estado?.nombre.toUpperCase()}`
                                : ""}

                            >

                            </Typeahead>

                            <div className="text-danger">
                              {errors.estado}
                            </div>
                          </Col>
                        </Row>
                      </Form.Group>
                    )}
                    <Form.Group>
                      <Form.Label className="custom-file-upload">
                        <i className="material-icons m-1">upload_file</i>
                        <input
                          type="file"
                          name="documento"
                          id="documento"
                          onChange={(e) => setFieldValue("documento", e.target.files[0])}
                        />
                        {editCompetencia.documento ? "Cambiar archivo" : "Subir archivo"}
                      </Form.Label>
                      <span className="file-name">{values.documento ? `${values.documento.name}` : editCompetencia.documento ? editCompetencia.documento.split("/").pop() : 'No se ha seleccionado un archivo'}</span>
                      {errors.documento && (
                        <div>
                          <span className="text-danger">{errors.documento}</span>
                        </div>
                      )}
                    </Form.Group>

                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      className="rounded-pill"
                      variant="secondary"
                      onClick={() => setShowModalCompetencia(false)}
                    >
                      Cerrar
                    </Button>
                    <Button
                      className="rounded-pill"
                      variant="primary"
                      disabled={saveLoading}
                      type="submit"


                    >
                      {" "}
                      {saveLoading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />

                      )}
                      Guardar

                    </Button>
                  </Modal.Footer>
                </Form>
              )}
            </Formik>

          </Modal>
        </div >

      )}



    </>


  );
};

export default PlanCarreraIndividual;
